<div
  *ngIf="ready && !visibility.isHidden"
  [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
>
  <div class="multiselect mw568" attr.data-columns="{{ columns }}">
    <app-content-multiselect-option
      *ngFor="let option of options; trackBy: trackByFn"
      [item]="option"
    >
    </app-content-multiselect-option>
  </div>
</div>
